import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className, lineClassName, delay = 0.1, as: Tag = 'span' }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span className="mask-line" key={i}>
        <motion.span
          className={lineClassName}
          initial={{ y: '110%' }}
          animate={{ y: '0%' }}
          transition={{ duration: 0.9, delay: delay + i * 0.09, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeIn = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.8, delay, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
);

export { EASE };